if (!customElements.get('facets-sort-menu')) {
  customElements.define(
    'facets-sort-menu',
    class FacetsSortMenu extends HTMLElement {
      constructor() {
        super();
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);

        // Everything inside .sorting is re-rendered by facets.js after each
        // update, so listen on the host (delegation) and look the <details>
        // up lazily instead of caching it.
        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener(
          'toggle',
          () => {
            const method = this.details && this.details.open ? 'addEventListener' : 'removeEventListener';
            document[method]('click', this.onDocumentClick);
            document[method]('keydown', this.onKeydown);
          },
          true
        );
      }

      get details() {
        return this.querySelector('details');
      }

      onChange(event) {
        const input = event.target;
        if (!input.matches('input[type="radio"][name="sort_by"]')) return;

        // Build from the live URL so active filters (and search terms) survive the sort change.
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', input.value);
        params.delete('page');

        this.close();

        if (typeof FacetFiltersForm !== 'undefined') {
          FacetFiltersForm.renderPage(params.toString(), null);
        } else {
          window.location.search = params.toString();
        }
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.close();
      }

      onKeydown(event) {
        if (event.key === 'Escape') this.close();
      }

      close() {
        const details = this.details;
        if (!details || !details.open) return;
        details.removeAttribute('open');
        const summary = details.querySelector('summary');
        if (summary) summary.focus({ preventScroll: true });
      }
    }
  );
}
